import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: "app-search-drop",
  templateUrl: "./search-drop.component.html",
  styleUrls: ["./search-drop.component.scss"],
})
export class SearchDropComponent implements OnInit {
  @Input() loadingSearch: boolean;

  @Input() searchList: any;
  constructor() {}

  ngOnInit(): void {}
}
